<template>
  <el-cascader
    placeholder="岗位地点"
    :options="options"
    :value="value"
    :show-all-levels="true"
    :props="{
      label: 're_name',
      value: 're_name',
      emitPath: false,
      checkStrictly: true,
    }"
    @change="handleChange"
    filterable
  ></el-cascader>
</template>

<script>
import { cityList } from "./city.js";
export default {
  name: "treeSelector",
  props: {
    value: [Number, String],
    type: {
      type: Number,
      default: 1,
    },
  },
  model: {
    prop: "value",
    event: "cc",
  },
  data: function () {
    return {
      options: [],
      childlist: [],
    };
  },
  mounted() {
    this.options = cityList;
    this.options.forEach((item) => {
      // 省份禁止选择
      item.disabled = true;
      // 保留两级
      item.children &&
        item.children.forEach((x) => {
          x.children = null;
        });
    });
  },
  watch: {},
  methods: {
    handleChange(e) {
      if (this.type != 2) {
        this.$emit("change", e);
      }
    },
  },
};
</script>

<style scoped></style>
